import { produce } from 'immer'
import { RemoteConfigModel } from 'src/models/remoteConfig.models'
import {
  GET_REMOTE_CONFIG_INIT,
  GET_REMOTE_CONFIG_SUCCESS,
  GetRemoteConfigActions,
  SET_REMOTE_CONFIG_ISSUE,
  SetRemoteConfigIssueActions,
} from 'src/redux/actions/session.actions'

export type Actions = GetRemoteConfigActions | SetRemoteConfigIssueActions

const RemoteConfigReducer = (
  state: RemoteConfigModel = RemoteConfigModel.defaultConfig(),
  action: Actions,
): RemoteConfigModel => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_REMOTE_CONFIG_INIT: {
        draft.loadingConfig = true
        draft.loadedConfig = false
        return draft
      }
      case GET_REMOTE_CONFIG_SUCCESS: {
        draft = action.payload
        draft.loadingConfig = false
        draft.loadedConfig = true
        return draft
      }
      case SET_REMOTE_CONFIG_ISSUE: {
        draft.configError = action.payload
        return draft
      }
    }
  })
}

export default RemoteConfigReducer
